export default "/assets/site/images/pdf_icon.png?dfb5d635a8ba8caacb74f500c0df6fb6";